module.exports = __webpack_public_path__ + "img/96.0010c7f5.jpg";